'use client';

import { useWishlistItems } from './use-wishlist-items';

/**
 * Hook to get the total count of items across all wishlists
 * Returns 0 if wishlist is not available or no items exist
 */
export function useWishlistItemCount(): number {
  const { data: allItems } = useWishlistItems();

  return allItems?.length || 0;
}
